module.exports = __webpack_public_path__ + "media/images/icon-svg/breadcrumb-arrow-78b5adf8e64549e9a700a7919d29bcc2.svg";